export default "__VITE_ASSET__vvCRwyZ___"